import axios from "axios";
import qs from "qs";
import { Link } from "react-router-dom";

import ResponsiveMaterialTable from "components/UI/MaterialTable/ResponsiveMaterialTable";
import { useAuth } from "hooks/useAuth";

import StageTracker from "./StageTracker";

export default function StageTrackerTable({ tableRef }) {
  const { authToken, permissions } = useAuth();

  const isCCTL = permissions.role_type === "Lab";

  const options = {
    sorting: true,
    columnsButton: true,
    pageSize: 20,
  };

  const columns = [
    {
      title: "VID",
      render: (rowData) =>
        permissions.role_type === "Vendor" ? (
          <strong>{rowData.v_id}</strong>
        ) : (
          <Link to={`products/details/${rowData.product_id}`}>
            <strong>{rowData.v_id}</strong>
          </Link>
        ),
    },
    {
      title: "Product",
      field: "product_name",
    },
    {
      title: "CCTL",
      field: "assigned_lab.name",
    },
    {
      title: "Project State",
      field: "stage",
      width: 400,
      render: (rowData) => <StageTracker rowData={rowData} />,
    },
  ];

  return (
    <>
      <div className="p-3 fw-bold">
        The Project State Tracker is designed to help you track the progress of
        projects as they flow through the Evaluation Process.
      </div>
      <ResponsiveMaterialTable
        title={"Project State Tracker"}
        tableRef={tableRef}
        data={(query) =>
          new Promise((resolve, reject) => {
            // Extract the necessary information from the query object
            const { page, pageSize, search, filters, orderBy, orderDirection } =
              query;

            let newFilters = filters.map((filter) => {
              let value = "";
              if (Array.isArray(filter.value)) {
                value = filter.value;
              } else {
                value = filter.value.replace(/['"]+/g, "");
              }
              return `"${filter.column.field.replace(/\./g, "__")}":"${value}"`;
            });
            const params = {
              offset: page * pageSize,
              limit: pageSize,
              search: search,
              filters: newFilters,
              orderBy: orderBy?.field,
              orderDirection: orderDirection,
            };
            axios
              .get(
                isCCTL
                  ? `${process.env.REACT_APP_DJANGO_ENDPOINT}project/product/stage_tracker_products/?${qs.stringify(params, { arrayFormat: "comma" })}`
                  : `${process.env.REACT_APP_DJANGO_ENDPOINT}project/product/my_validations/?${qs.stringify(params, { arrayFormat: "comma" })}`,
                {
                  withCredentials: true,
                  headers: {
                    Authorization: `Token ${authToken}`,
                  },
                },
              )
              .then((response) => {
                resolve({
                  data: response.data.results,
                  page: page,
                  totalCount: response.data.count,
                });
              })
              .catch((error) => {
                reject(error);
              });
          })
        }
        options={options}
        columns={columns}
      />
    </>
  );
}
